import React from 'react'
import { router } from '@inertiajs/react'
import Layout from '../Layout'
import DataTable from '../../../Components/DataTable'
import Button from '../../../Components/Button'
import ResourceIndexHeader from '../../../Components/ResourceIndexHeader'
import { useDeleteWithConfirmation } from '../../../hooks/useDeleteWithConfirmation'

export default function Index({ account, accounts, navigation, courses, params = {} }) {
  const handleDelete = useDeleteWithConfirmation('/manage/courses')

  const columns = [
    {
      key: 'name',
      label: 'Name',
      sortable: true,
      className: 'font-medium text-gray-900'
    },
    {
      key: 'hole_count',
      label: 'Holes',
      sortable: true,
      render: (value, item) => (
        <span className="text-gray-500">
          {value} holes ({item.holes_count} configured)
        </span>
      )
    }
  ]

  return (
    <Layout account={account} accounts={accounts} navigation={navigation} title="Courses">
      <ResourceIndexHeader
        count={courses.length}
        singular="course"
        plural="courses"
        addHref="/manage/courses/new"
        addLabel="Add Course"
      />

      <DataTable
        data={courses}
        columns={columns}
        actions={(item) => (
          <>
            <Button link href={`/manage/courses/${item.id}/edit`}>Edit</Button>
            <Button
              link
              variant="danger"
              onClick={() => handleDelete(item, {
                customMessage: `Delete "${item.name}"? This will also delete all holes. This cannot be undone.`
              })}
            >
              Delete
            </Button>
          </>
        )}
        searchable={true}
        searchPlaceholder="Search courses..."
        emptyState={{
          message: 'No courses yet',
          action: { label: 'Create your first course', href: '/manage/courses/new' }
        }}
        baseUrl="/manage/courses"
        params={params}
      />
    </Layout>
  )
}
